import React, { useEffect, useState, useContext, ReactChild, ReactElement } from "react";
import { LoginFormContext } from "../../utils";
import {
  IconSwitch,
  IconRight,
  IconTopUp,
  IconGroup,
  IconJoyMeetingGroup,
  IconArrowLeft
} from "@/components/icon";
import { BackNav } from "../../comps";
import {
  approveStatusEnum,
  ApprovaTeamUserInfo,
  ApprovaTeamUserInfoList,
  TeamUserInfo,
  UserType
} from "@/types/LoginPage";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";
import colors from "@/components/styles/colors";
// import "../index.less";
import stylesLess from '../index.module.less'
import stylesLess1 from '../../index.module.less'
import { message } from "antd";
import ApplyingTeams from "./ApplyingTeams";
import { Avatar } from "@/baseComponents/Avatar";
const { REACT_APP_DEFAULT_COUNTRY_CODE: DEFAULT_COUNTRY_CODE = 86 } = process.env;
const countryCode = DEFAULT_COUNTRY_CODE;

export function TeamItem({
  title,
  name,
  desc,
  styles,
  clickHandle,
  rightComps
}: {
  title: string;
  name: string;
  desc?: string | number;
  styles?: any;
  clickHandle: () => void;
  rightComps?: React.ReactNode;
}) {
  return (
    <div
      onClick={clickHandle}
      className={stylesLess1.teamItem}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        marginBottom: "12px",
        borderRadius: "8px",
        // boxShadow: "0px 8px 20px 0px rgba(0,0,0,0.1)"
        border: "0.8px solid #E6E6E6"
      }}
    >
      <Avatar
          name={title}
          type="team"
          styleObj={{
            width: 44, height: 44, borderRadius: 0, fontSize: 13, background: "#1686FF"
          }}
        />
      {/* <p
        className={`avatar-mask ${stylesLess1.title} ${stylesLess["join-me-primary-bg"]}`}
        style={{
          width: "44px",
          lineHeight: "44px",
          // background: color.primary,
          // borderRadius: "18px",
          margin: 0,
          color: "#fff"
        }}
      >
        {title}
      </p> */}
      <div
        style={{
          flex: 1,
          overflow: "hidden",
          marginLeft: "15px"
        }}
      >
        <p
          style={{
            fontSize: "16px",
            color: "#000",
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {name}
        </p>
        <p style={styles}>{desc}</p>
      </div>
      {rightComps ?? IconRight}
    </div>
  );
}
export default function SelectTeam({
  teamUserInfoList = [],
  onSelectTeam,
  showActive
}: {
  teamUserInfoList: TeamUserInfo[];
  onSelectTeam: (id: string) => void;
  showActive: (team: TeamUserInfo) => void;
}) {
  const { t } = useTranslation("common");
  const { navigate, onMobileChange, setResendLastTs } = useContext(LoginFormContext);
  const [teamUserInfoStateList, setTeamUserInfoStateList] = useState(teamUserInfoList);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  let {mobile, loginType} = useContext(LoginFormContext);  
  mobile = mobile || teamUserInfoList[0].mobile;    
  return (
    <div
      className={`${stylesLess1.mobileForm} ${stylesLess1.joinMe}`}
      style={{
        border: "1px solid rgba(240,243,243,1)",
        borderRadius: "6px",
        padding: 0
      }}
    >
      <div
        style={
          {
            // padding: "20px 30px 0 30px"
          }
        }
      >
        <BackNav
          clickHandle={() => {
            onMobileChange("");
            setResendLastTs(-1);
            setTimeout(() => {
              navigate("step1");
            }, 0);
          }}
          icon={IconArrowLeft}
          title={t("login.changeLogin")}
          subtitle={t("login.selectTeam")}
          desc={t("login.enterJoinedTeam")}
          mobile={`${loginType === "MOBILE" ? countryCode : ""} ${mobile.substring(0, 3)}****${mobile.substring(7)}`}
        />
      </div>
      <div>
        <div className={stylesLess1.selectTeam}>
          <div className={stylesLess1.teamScroller}>
            {teamUserInfoStateList?.map((item: TeamUserInfo, index: number) => {
              return (
                <TeamItem
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${item.teamId}-${index}`}
                  title={item.teamFullName}
                  name={item.teamFullName}
                  clickHandle={() => {
                    if (item.emplEnabled !== "DIS_ENABLED") {
                      onSelectTeam(item.teamId);
                    } else if (item.userType === UserType.EXTERNAL) {
                      showActive(item);
                    } else {
                      message.destroy();
                      message.warn("该账号已被冻结，如有疑问请联系所在单位管理员进行核查。");
                    }
                  }}
                />
              );
            })}
            <ApplyingTeams />
          </div>
        </div>
      </div>
    </div>
  );
}
